

















import { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { ResultSlots } from '../components.const';
import { ChevronLeftIcon, ChevronRightIcon } from '../icons';

@Component({
  components: {
    ChevronLeftIcon,
    ChevronRightIcon
  }
})
export default class ResultSlideshow extends Vue {
  // TODO - Refactor component when the adapter is merged

  @Prop({ required: true })
  item: Result;

  slideshowPreviousIconSlotName = ResultSlots.slideshowPreviousIcon;
  slideshowNextIconSlotName = ResultSlots.slideshowNextIcon;

  showPreviousImg() {
    const orderedImages = [...this.item.images];
    orderedImages.unshift(orderedImages.pop());
    this.updateResultImages(orderedImages);
  }

  showNextImg() {
    const orderedImages = [...this.item.images];
    orderedImages.push(orderedImages.shift());
    this.updateResultImages(orderedImages);
  }

  private updateResultImages(images: string[]) {
    this.$x.emit(EVENTS.UpdateResult, {
      result: this.item,
      update: { images: images }
    });
  }
}
